import classNames from 'classnames';
import { Badge } from 'components-antd';
import Icons from 'pages/FormBuilder/Icons';
import styles from './styles.module.scss';
import { useManageFormComments } from '../../../FieldRenderer/FormComments/hooks/useManageFormComments';

export const CommentBadgeIcon = (props) => {
  const { headerWidget, fillWhite } = props;
  const { formsComments } = useManageFormComments();

  const getUnresolvedComments = () => {
    const threads: any[] = Object.values(formsComments).flat();
    if (!threads.length) return 0;

    return threads.filter((item) => !item.Resolved && item.Comments.length).length;
  };

  return (
    <div
      className={classNames(styles.commentsIcon, {
        [styles.formHeaderCommentIcon]: headerWidget,
      })}
    >
      <Badge
        count={getUnresolvedComments()}
        overflowCount={5}
        className={classNames(styles.commentsBadge, { [styles.fillWhiteSvg]: fillWhite })}
      >
        <Icons variant="commentDrawer" />
      </Badge>
    </div>
  );
};
